import React from "react";
import { Box, BoxProps } from "@chakra-ui/react";
import { motion } from "framer-motion";

interface FloatingProps {
  top?: any;
  right?: any;
  bottom?: any;
  left?: any;
  delay: number;
  text: string;
}

const FloatingStat = ({
  top,
  right,
  bottom,
  left,
  delay,
  text,
}: FloatingProps): JSX.Element => {
  const MotionBox = motion<Omit<BoxProps, "transition">>(Box);

  return (
    <MotionBox
      position={"absolute"}
      border={"1px solid white"}
      borderRadius={"lg"}
      backdropFilter={"blur(6px)"}
      backgroundColor="rgba(255, 255, 255, 0.2)"
      color={"white"}
      fontWeight={"bold"}
      padding={{ base: 2, md: 3 }}
      as={motion.div}
      animate={{
        x: [0, 4, -2, 6, -2, 2, 0],
        y: [0, -6, 2, -4, 6, -2, 0],
        rotate: [0, 2, -2, 1, -1, 0],
      }}
      transition={{
        duration: 10,
        repeat: Infinity,
        repeatType: "mirror",
        ease: "easeInOut",
        delay: delay,
      }}
      top={top}
      right={right}
      bottom={bottom}
      left={left}
    >
      {text}
    </MotionBox>
  );
};

export default FloatingStat;
